import { render, staticRenderFns } from "./OrderFeedBack.vue?vue&type=template&id=3948a1ea&scoped=true"
import script from "./OrderFeedBack.vue?vue&type=script&lang=js"
export * from "./OrderFeedBack.vue?vue&type=script&lang=js"
import style0 from "./OrderFeedBack.vue?vue&type=style&index=0&id=3948a1ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948a1ea",
  null
  
)

export default component.exports